/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Buyer_ProtectedInputs */

const en_buyer_protected = /** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buyer Protected`)
};

const id_buyer_protected = /** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pembeli Dilindungi`)
};

/** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */
const es_buyer_protected = en_buyer_protected;

/** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */
const fr_buyer_protected = en_buyer_protected;

/** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */
const de_buyer_protected = en_buyer_protected;

/** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */
const ja_buyer_protected = en_buyer_protected;

/** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */
const zh_buyer_protected = en_buyer_protected;

/** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */
const ar_buyer_protected = en_buyer_protected;

/** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */
const it_buyer_protected = en_buyer_protected;

/** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */
const ru_buyer_protected = en_buyer_protected;

/** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */
const pt_buyer_protected = en_buyer_protected;

/** @type {(inputs: Buyer_ProtectedInputs) => LocalizedString} */
const ko_buyer_protected = en_buyer_protected;

/**
* | output |
* | --- |
* | "Buyer Protected" |
*
* @param {Buyer_ProtectedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const buyer_protected = /** @type {((inputs?: Buyer_ProtectedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Buyer_ProtectedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_buyer_protected(inputs)
	if (locale === "es") return es_buyer_protected(inputs)
	if (locale === "fr") return fr_buyer_protected(inputs)
	if (locale === "de") return de_buyer_protected(inputs)
	if (locale === "ja") return ja_buyer_protected(inputs)
	if (locale === "zh") return zh_buyer_protected(inputs)
	if (locale === "ar") return ar_buyer_protected(inputs)
	if (locale === "id") return id_buyer_protected(inputs)
	if (locale === "it") return it_buyer_protected(inputs)
	if (locale === "ru") return ru_buyer_protected(inputs)
	if (locale === "pt") return pt_buyer_protected(inputs)
	return ko_buyer_protected(inputs)
});